<template>
<div>
  
        <el-row class="monitor-header-two" :gutter="20" style="margin-bottom: 20px;">
          <el-col :span="24">
             <el-page-header @back="goBack" content="More Announcement"></el-page-header>

          </el-col>
          <el-col :span="24">
            <!-- 卡片视图区域 -->
    
          
            <!-- 列表区域 -->
            <el-table
              :data="dataList"
              @sort-change="sortChange"
              @row-click="dbClickHandler"
            >
              <el-table-column type="index" label="No."  width="150"  class-name="column_cursor"></el-table-column>
              <el-table-column label="Title" sortable="custom" prop="title" class-name="column_cursor"></el-table-column>
              <el-table-column label="Date" sortable="custom" prop="startTime" width="250"  class-name="column_cursor"></el-table-column>
            </el-table>

            <!-- 分页区域 -->
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="queryInfoparams.current"
              :page-sizes="[20, 50, 100, 200]"
              :page-size="queryInfoparams.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            ></el-pagination>
    
              <notify-dialog
                    ref="notifyDialog"
                    :dialogVisible="dialogVisible"
                    @closeDialog="closeDialog"
                ></notify-dialog>
          </el-col>
        </el-row>
       
</div>
</template>

<script>
import NotifyDialog from './NotifyDialog.vue'
export default {
     components: {
        NotifyDialog
    },
    data(){
        return {
           // 获取列表的参数对象
            queryInfoparams: {
              // 当前页码
              current: 0,
              // 查询参数
              params: {},
              // 当前每页显示多少条数据
              size: 20,
              // 排序字段
              sortField: '',
              // ASC  DESC 顺序
              sortOrder: '',
            },
            // 列表
            dataList: [],
            total: 0,
            tableData: [],
            multipleSelection: [],
            dialogVisible:false,
        }
    },
    created(){
        this.getDataList()
    },
    methods: {
        // 返回
        goBack() {
          this.$router.back()
        },
        dbClickHandler(row, column, event){
            console.log('row',row)

             this.dialogVisible = true
            this.$refs.notifyDialog.setId(row.id,row.isRead)

        },
        click(row){

             this.dialogVisible = true
            this.$refs.notifyDialog.setId(row.id,row.isRead)
        },
        closeDialog(){
            this.dialogVisible = false
        },

          //监听字段排序
        sortChange(r) {
          //设置排序字段名
          this.queryInfoparams.sortField = r.prop
          //设置排序字段名
          this.queryInfoparams.sortOrder = r.order

          this.getDataList()
        },
        // 获取 查询用户数据列表
        getDataList() {
          // 分页查询
          this.$post('notify/myPageQuery', this.queryInfoparams).then(
            ({ data: res }) => {
              this.dataList = res.records
              this.total = res.total
            }
          )
        },
        // 监听pagesize改变的事件
        handleSizeChange(newSize) {
          this.queryInfoparams.size = newSize
          this.getDataList()
        },
        // 监听页码值 改变的事件
        handleCurrentChange(newPage) {
          this.queryInfoparams.current = newPage
          this.getDataList()
        },
    }
}
</script>

<style  lang="less" scoped>
.Information-table{
    width: 100%;
    height: 100%;
    padding-bottom: 20px;
    margin-top: 0px;
}
.message-title{
    cursor: pointer;
    font-size: 14px;;
}
.message-date{
    cursor: pointer;
}
.read-color{
    font-size: 40px;
    color: rgb(197, 6, 6);
    cursor: pointer;
}
.monitor-info-name {
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  justify-content: space-between;
}

.monitor-subtext-map {
  width: 100%;
  /* height: 20px; */
  /* margin-top: -20px; */
  display: flex;
  justify-content: space-between;
  color: #5c5c5c;
  font-size: 14px;
  float: left;
}
.monitor-cart-name-left {
  width: 260px;
  height: 100%;
  /* background: blueviolet; */
  line-height: 42px;
  color: #5c5c5c;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
}
.monitor-cart-name-left-icon {
  width: 30px;
  height: 30px;
  background: #f7eeff;
  border-radius: 2px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
}
.monitor-cart-name-left-icon-s {
  width: 20px;
  height: 20px;
  color: blueviolet;
  fill: currentColor;
}
.monitor-cart-name-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 20px;
  cursor: pointer;
}

.monitor-cart-name-right-list {
  width: 60px;
  height: 50px;
  /* background: chartreuse; */
  text-align: center;
  line-height: 50px;
  color: #515a6e;
  font-size: 14px;
  cursor: pointer;
}
.monitor-cart-name-right-list:hover {
  color: #2d8cf0;
}
.monitor-cart-box {
  /*background: chocolate;*/
  width: 100%;
  height: 100px;
  padding: 10px 5px;
  box-sizing: border-box;
  /* border: 1px solid #E6E6E6; */
  background: #ffffff;
  border-radius: 5px;
  margin-bottom: 20px;
}
/deep/.column_cursor:hover{
  cursor: pointer;
}
</style>